import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {usersStore} from '@store/settings/users/users.store';

export const getUsersDataSource = createRequestDataSource({
  store: usersStore,
  data$: () => usersStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getUsers',
  dataKey: 'users',
});
